import commonApi from '../service/common_api'
import Util from '../lib/utils'

export default {
    data() {
        return {
            resultStr: '',
            langType: ''
        }
    },
    methods: {
        // 操作二次确认，文字提醒
        textConfirm(text) {
            return new Promise((resolve, reject) => {
                this.$confirm(text, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    resolve();
                }).catch(() => {
                    // codes...
                });
            });
        },

        // 操作二次确认，需填写密码
        pwdConfirm() {
            return new Promise((resolve, reject) => {
                this.$prompt('请输入密码', '谨慎操作！！！', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator: (str) => {
                        return str != null && str != ''
                    },
                    inputErrorMessage: '密码不能为空'
                }).then(({
                    value
                }) => {
                    resolve(value);
                }).catch(() => {
                    // codes...
                });
            })
        },

        // 校验数据是否为空(null/'')
        checkDataEmpty(data) {
            if (data === null || data === '') {
                return true
            }
        },

        // 校验是否已选游戏服
        checkIsSelect(data) {
            if (data.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '请先选择区服'
                })
                return true;
            } else {
                return false;
            }
        },

        // 获取语言包
        getLangs() {
            this.langType = [];
            commonApi.getLangs().then(res => {
                this.$i18n.mergeLocaleMessage('cn', res.cn);
                this.$i18n.mergeLocaleMessage('hant', res.hant);
                this.$i18n.mergeLocaleMessage('en', res.en);
                this.$i18n.mergeLocaleMessage('jp', res.jp);
                this.$i18n.mergeLocaleMessage('kr', res.kr);
                var langArr = res.langType.split(',');
                langArr.forEach(item => {
                    if (item == 'cn') {
                        this.langType.push({
                            id: 1,
                            label: '简中',
                            val: "zh-Hans",
                            value: item
                        })
                    } else if (item == 'hant') {
                        this.langType.push({
                            id: 2,
                            label: '繁中',
                            val: "zh-Hant",
                            value: item
                        })
                    } else if (item == 'en') {
                        this.langType.push({
                            id: 3,
                            label: '英文',
                            val: "en-US",
                            value: item
                        })
                    }
                })
                Util.setCookie('langType', this.langType);
            })

        },

        toEast8Time(date) {
            const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);
            return new Date(utcTime + (8 * 60 * 60 * 1000));
        },

        toWest5Time(date) {
            const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);
            return new Date(utcTime - (5 * 60 * 60 * 1000));
        },

        west5TimeToEast8Time(date) {
            const utcTime = date.getTime();
            return new Date(utcTime + (13 * 60 * 60 * 1000));
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/action_confirm.js